import { useState, useEffect, useRef } from 'react';

interface LazyVideoProps {
    src: string;
    className?: string;
    threshold?: number;
    loop?: boolean;
}

export const LazyVideo = ({ src, className = '', threshold = 0.1, loop = true }: LazyVideoProps) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const videoElement = videoRef.current;
        if (!videoElement) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !isLoaded) {
                        setIsLoaded(true);
                    }
                });
            },
            {
                threshold,
                rootMargin: '50px'
            }
        );

        observer.observe(videoElement);

        return () => {
            observer.disconnect();
        };
    }, [isLoaded, threshold]);

    return (
        <video
            ref={videoRef}
            autoPlay={isLoaded}
            muted
            loop={loop}
            playsInline
            src={isLoaded ? src : undefined}
            className={className}
        />
    );
}
